var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { SHUTTER_MATERIAL_CHOICES } from '@shared/constants/breakInDamages/ShutterConstants';
import { ROLLING_SHUTTER_IS_MOTORIZED_CHOICES } from '@declaration/constants/breakInDamages/ShutterConstants';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let RollingShutterMotorization = class RollingShutterMotorization extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
        this.ROLLING_SHUTTER_IS_MOTORIZED_CHOICES = ROLLING_SHUTTER_IS_MOTORIZED_CHOICES;
        this.SHUTTER_MATERIAL_CHOICES = SHUTTER_MATERIAL_CHOICES;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('rollingShutterIsMotorized') &&
            !this.validation.fieldHasViolations('material'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], RollingShutterMotorization.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], RollingShutterMotorization.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], RollingShutterMotorization.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], RollingShutterMotorization.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], RollingShutterMotorization.prototype, "validateBreakInDamage", void 0);
RollingShutterMotorization = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionSubSection,
            BreakInDamageChoices,
            RadioPrimaryButton,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageDescriptionStep,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], RollingShutterMotorization);
export default RollingShutterMotorization;
